import { Component, OnInit, OnDestroy, Renderer2, Inject } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs';

@Component({
  selector: 'app-meet-business',
  imports: [CommonModule],
  standalone: true,
  templateUrl: './meet-business.component.html',
  styleUrl: './meet-business.component.scss'
})
export class MeetBusinessComponent implements OnInit, OnDestroy {
  private jsonLdScript: any;
  constructor(private router: Router, private activatedRoute: ActivatedRoute,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private _document: Document
  ) { }
  nav(url: any) {
    console.log(url);
    this.router.navigateByUrl(url)
  }
  ngOnInit(): void {
    this.injectSchemaMarkup();
    this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map((route) => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route: { data: any; }) => route.data)
    )
  }
  ngOnDestroy(): void {
    this.removeSchemaMarkup();
  }
  injectSchemaMarkup(): void {
    const erpCaseStudySchema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://www.kalpitatechnologies.com/kalpita-case-studies/meet-business",
          "url": "https://www.kalpitatechnologies.com/kalpita-case-studies/meet-business",
          "name": "Meet Your Business Goals with Proven ERP Methodologies | Kalpita Case Study",
          "description": "Kalpita Technologies helps businesses adapt their workforce to business strategy with customized agile roadmaps on SAP HCM and SuccessFactors modules.",
          "isPartOf": { "@id": "https://www.kalpitatechnologies.com/#website" },
          "inLanguage": "en",
          "datePublished": "2024-01-15"
        },
        {
          "@type": "BreadcrumbList",
          "@id": "https://www.kalpitatechnologies.com/kalpita-case-studies/meet-business#breadcrumb",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "item": { "@type": "WebPage", "@id": "https://www.kalpitatechnologies.com/", "name": "Home" } },
            { "@type": "ListItem", "position": 2, "item": { "@type": "WebPage", "@id": "https://www.kalpitatechnologies.com/kalpita-case-studies/case-study", "name": "Case Studies" } },
            { "@type": "ListItem", "position": 3, "item": { "@type": "WebPage", "@id": "https://www.kalpitatechnologies.com/kalpita-case-studies/meet-business", "name": "ERP Implementation" } }
          ]
        },
        {
          "@type": "Article",
          "headline": "Meet Your Business Goals with Proven ERP Methodologies at Your Fingertips",
          "articleBody": "Kalpita Technologies is well versed in assisting businesses to adapt their workforce to business strategy with customized agile roadmaps... on the SAP HCM and SuccessFactors modules...",
          "author": { "@type": "Organization", "name": "Kalpita Technologies" },
          "publisher": {
            "@type": "Organization",
            "name": "Kalpita Technologies",
            "logo": { "@type": "ImageObject", "url": "https://www.kalpitatechnologies.com/assets/common/black-logo.png" }
          },
          "datePublished": "2024-01-15",
          "image": "https://www.kalpitatechnologies.com/assets/resources/casestudies/meetbusiness-computer.webp"
        },
        {
          "@type": "HowTo",
          "name": "How to Implement SAP ERP with Kalpita's 5-Step Methodology",
          "step": [
            { "@type": "HowToStep", "name": "Project Preparation", "text": "Requirement study, solution design, and project planning." },
            { "@type": "HowToStep", "name": "Business Blueprint", "text": "Detailed documentation and baseline configuration analysis." },
            { "@type": "HowToStep", "name": "Realization", "text": "Execute system configuration in two work packages." },
            { "@type": "HowToStep", "name": "Final Preparation", "text": "Testing, end user training, and cutover activities." },
            { "@type": "HowToStep", "name": "Go Live", "text": "Move to live production operation." }
          ]
        },
        {
          "@type": "FAQPage",
          "@id": "https://www.kalpitatechnologies.com/kalpita-case-studies/meet-business#faq",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What SAP modules does Kalpita Technologies specialize in?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Kalpita Technologies specializes in SAP HCM (Human Capital Management) and SAP SuccessFactors modules including Payroll, Time Management, and ESS/MSS."
              }
            }
          ]
        },
        {
          "@type": "Organization",
          "@id": "https://www.kalpitatechnologies.com/#organization",
          "name": "Kalpita Technologies",
          "url": "https://www.kalpitatechnologies.com/",
          "logo": { "@type": "ImageObject", "url": "https://www.kalpitatechnologies.com/assets/common/black-logo.png" }
        }
      ]
    };

    this.jsonLdScript = this.renderer.createElement('script');
    this.jsonLdScript.type = 'application/ld+json';
    this.jsonLdScript.text = JSON.stringify(erpCaseStudySchema);
    this.renderer.appendChild(this._document.head, this.jsonLdScript);
  }

  removeSchemaMarkup(): void {
    if (this.jsonLdScript) {
      this.renderer.removeChild(this._document.head, this.jsonLdScript);
      this.jsonLdScript = null;
    }
  }
}
